import { Box, Grid } from "@mui/material";
import { COUNTRY_CODES, timeZoneItems } from "../../../../common/constants";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormPasswordFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

import { LabelCaption } from "../../../../common/AppMessages";

interface IUsersInfoSetupFieldsPanel { formMethods: any, id: string | undefined }
export const UsersInfoSetupFieldsPanel: FC<
	IUsersInfoSetupFieldsPanel
> = ({ formMethods, id }) => {
	const [CountryCodeValue, setCountryCodeValue] = useState<any>("+1");
	const [PhoneNumberPlaceholder, setPhoneNumberPlaceholder] =
		useState<any>("(123) 456-7890");
	const [PhoneNumberInputMaskPattern, setPhoneNumberInputMaskPattern] =
		useState<any>("(000) 000-0000");
	const onCountryCodeSelectionChangeHandler = (selectedCountry: any) => {
		const foundCountry = COUNTRY_CODES.find(
			(c) => c.value === selectedCountry.value
		);
		if (foundCountry) {
			formMethods.setValue("phone", "");
			setCountryCodeValue(foundCountry.value);
			setPhoneNumberInputMaskPattern(foundCountry.mask);
			setPhoneNumberPlaceholder(foundCountry.placeholder);
		}
	};
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="First Name"
				id="firstName"
				testId={`firstName`}
			/>
			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`lastName`}
			/>
			<EmailFieldRHF
				label="Email"
				id="email"
				testId={`email`}
				readOnly={id ? true : false}
			/>
			{/* <RHookFormPasswordFieldWithLabel
				id="choosePassword"
				testId={`user-authentication-new-password`}
				label="Choose password"
				placeholder="Choose password"
			/>
			<RHookFormPasswordFieldWithLabel
				id="confirmPassword"
				testId={`user-authentication-confirm-new-password`}
				label="Confirm password"
				placeholder="Confirm password"
			/> */}

			{/* <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} spacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
					sx={{ display: "flex", alignItems: "center" }}
				>
					<EnhancedDropDownRHFWithLabel
						label="Country Code"
						testId="country-code-field"
						selectName="countryCode"
						items={COUNTRY_CODES}
						onSelectionChangeHandler={onCountryCodeSelectionChangeHandler}
						selectedItem={CountryCodeValue}
					/>
					<span
						style={{
							marginBottom: "0.7rem",
							marginLeft: "1rem",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						{CountryCodeValue}
					</span>
				</Grid>

				<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
					{/* <RHookFormTextFieldWithLabel
						label="Phone Number"
						fieldValue="phone"
						id="phone"
						testId="phone-field"
						placeholder={PhoneNumberPlaceholder}
					/> 
					<RHookFormMaskedTextFieldWithLabel
						label="Phone Number"
						id="phone"
						testId="phone-field"
						labelPosition={LabelPosition.Top}
						placeholder={PhoneNumberPlaceholder}
						inputMaskPattern={PhoneNumberInputMaskPattern}
					/>
				</Grid>
			</Grid> */}

			<EnhancedDropDownRHFWithLabel
				selectName="timezone"
				label={LabelCaption.timezone}
				required
				testId={`time-zone-items-list`}
				items={timeZoneItems}
				selectedItem={"(GMT-05:00) Eastern Time (US & Canada)"}
			/>
			<RHookFormTextFieldWithLabel
				label="IP Address"
				id="ipAddress"
				testId={`ipAddress`}
			/>
			{/* <EnhancedDropDownRHFWithLabel
				label="Status"
				selectName="status"
				testId={`Status`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Active", value: 100 },
					{ label: "In-Active", value: 200 },
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/> */}
		</Box>
	);
};
